<template>
    <fade-transition :delay="delay" :duration="{enter:500}">
        <div v-show="show" :class="classes">
            <div v-if="contact.title.length" class="content__sectionTitle">
                {{contact.title}}
            </div>

            <div class="content__info">
                <a class="" :href="content.link" title="" target="_blank">
                    <fade-transition :delay="500" :duration="{enter:500}">
                        <img v-show="show" :src="content.url" alt="" title="">
                    </fade-transition>
                </a>
            </div>
        </div>
    </fade-transition>
</template>

<script>
    import {preloadImg} from '../utils/shared'

    export default {
        props: [
            'contact',
            'delay',
        ],
        data() {
            return {
                show: false,
            }
        },
        computed: {
            content() {
                return this.contact.content[0]
            },
            classes() {
                return [
                    //'content__section content__section-generalInfo',
                    'content__section content__section-map',
                    {'content__section-withTitle': this.contact.title.length},
                ]
            },
        },
        mounted() {
            preloadImg(this.content.url)
                .then(() => {
                    this.show = true
                }).catch(() => {})
        },
        methods: {}
    }
</script>
